import { SuggestedVariantOptions } from "@redotech/redo-model/agents/returns-agents/suggested-variant-options/suggested-variant-options";
import { createContext, ReactNode, useState } from "react";
import { RecommendedExchangeProductData } from "../hooks/use-recommended-exchange/use-recommended-exchange";
import { ExchangeGroupByProductId } from "../hooks/useFlow/use-exchange-groups";

export const SuggestedExchangeOptionsContext = createContext<{
  exchangeGroupsByProductId: ExchangeGroupByProductId | undefined;
  setExchangeGroupsByProductId: (
    exchangeGroupsByProductId: ExchangeGroupByProductId | undefined,
  ) => void;
  suggestedVariantOptions: SuggestedVariantOptions | undefined;
  setSuggestedVariantOptions: (
    suggestedVariantOptions: SuggestedVariantOptions | undefined,
  ) => void;
  exchangeRecommendations: RecommendedExchangeProductData[];
  setExchangeRecommendations: (
    exchangeRecommendations: RecommendedExchangeProductData[],
  ) => void;
}>({
  exchangeGroupsByProductId: undefined,
  setExchangeGroupsByProductId: () => {},
  suggestedVariantOptions: undefined,
  setSuggestedVariantOptions: () => {},
  exchangeRecommendations: [],
  setExchangeRecommendations: () => {},
});

export const SuggestedExchangeOptionsProvider = ({
  children,
}: {
  children: ReactNode;
}) => {
  const [suggestedVariantOptions, setSuggestedVariantOptions] = useState<
    SuggestedVariantOptions | undefined
  >(undefined);
  const [exchangeGroupsByProductId, setExchangeGroupsByProductId] = useState<
    ExchangeGroupByProductId | undefined
  >(undefined);
  const [exchangeRecommendations, setExchangeRecommendations] = useState<
    RecommendedExchangeProductData[]
  >([]);

  return (
    <SuggestedExchangeOptionsContext.Provider
      value={{
        exchangeGroupsByProductId,
        setExchangeGroupsByProductId: (value) => {
          setExchangeGroupsByProductId(value);
        },
        suggestedVariantOptions,
        setSuggestedVariantOptions: (value) => {
          setSuggestedVariantOptions(value);
        },
        exchangeRecommendations,
        setExchangeRecommendations: (value) => {
          setExchangeRecommendations(value);
        },
      }}
    >
      {children}
    </SuggestedExchangeOptionsContext.Provider>
  );
};
